

import React, { createContext, useContext, useState } from "react";
import { useDiscount } from "./DiscountContext";
import * as api from "../api/index";
import { StockContext } from "./StockContext";
import { useOrderSession } from "./OrderSessionContext";

const CartContext = createContext();
export function useCart() {
  return useContext(CartContext);
}

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState([]);
  const [QtydialogOpen, setQtyDialogOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [receivedAmount, setReceivedAmount] = useState("");
  const [vat, setVat] = useState();
  const profileDetail = JSON.parse(localStorage.getItem("profileDetail"));
  const profile = JSON.parse(localStorage.getItem("profile"));
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [minQtyAlerted, setMinQtyAlerted] = useState({});

  const { discountFlag, clearDiscount, discountVal, discountType, discountRate } = useDiscount();
  const { getCurrentStockQty, getConvertedQuantity } = useContext(StockContext);
  const orderSession = useOrderSession();

  const parsePriceValue = (value) => {
    if (value === "" || value === null || value === undefined) return null;
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const getOriginalUnitPrice = (item) => {
    const raw =
      item?.originalPrice ??
      item?.units?.sale?.price ??
      item?.rate ??
      item?.price ??
      0;
    const parsed = parseFloat(raw);
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const getEffectiveUnitPrice = (item) => {
    const override = parsePriceValue(item?.overridePrice);
    if (override != null && override > 0) {
      return override;
    }
    const raw =
      item?.units?.sale?.price ??
      item?.rate ??
      item?.originalPrice ??
      item?.price ??
      0;
    const parsed = parseFloat(raw);
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const isItemPriceAdjusted = (item) => {
    const base = getOriginalUnitPrice(item);
    const effective = getEffectiveUnitPrice(item);
    return Math.abs(effective - base) > 0.0001;
  };

// Helper to determine VAT type (inclusive or exclusive)
const isVatInclusive = () => {
  return (
    profileDetail?.vatType === "inclusive" || 
    profile?.userProfile?.vatType === "inclusive"
  );
};

// console.log(profileDetail)
// console.log(profile)


// Helper to determine VAT rate (item-based or common)
const getVatRate = (item) => {
  if (profileDetail?.vatOptions === "common") {
    return parseFloat(profileDetail?.commonVatRate) || 0;
  }
  return parseFloat(item.vat) || 0; // Item-based VAT
};


  const filterItemsByCategory = (category) => {
    setSelectedCategory(category);
    setSearchQuery("");
  };

  const getInvoiceNumber = async () => {
    const { data } = await api.fetchInvoicesCount();
    return (data + 1).toString();
  };

  // const handleAddToCart = async (item, quantity) => {
  //   const data = await getCurrentStockQty(item._id);
  //   const convertedQty = await getConvertedQuantity({ ...item, quantity }, "sale");
  //   const updatedCartItems = [...cartItems];
  //   const existingItem = updatedCartItems.find((cartItem) => cartItem._id === item._id);
  
  //   if (existingItem) {
  //     const existingConvertedQty = await getConvertedQuantity(existingItem, "sale");
  //     if (existingItem.isStaffReq) {
  //       existingItem.quantity = quantity;
  //       console.log("existing item Updated Quantity", existingItem.quantity);
  //     } else if (existingItem.toggleStock) {
  //       const remainingStock = data.currentStock + existingConvertedQty;
  //       if (remainingStock <= 0) {
  //         alert(`Not enough stock for ${existingItem.itemName}`);
  //         return;
  //       }
  //       if (remainingStock <= existingItem.stockQty.minQty && !minQtyAlerted[existingItem._id]) {
  //         alert(`Minimum Quantity Reached for ${existingItem.itemName}`);
  //         setMinQtyAlerted((prev) => ({
  //           ...prev,
  //           [existingItem._id]: true,
  //         }));
  //       }
  //       existingItem.quantity++;
  //       existingItem.isLowStock = remainingStock <= existingItem.stockQty.minQty;
  //     } else {
  //       existingItem.quantity++;
  //     }
  //   } else {
  //     if (item.isStaffReq) {
  //       updatedCartItems.push({ ...item, quantity });
  //     } else if (item.toggleStock) {
  //       // Check stock before adding new item
  //       if (data.currentStock <= 0) {
  //         alert(`Not enough stock for ${item.itemName}`);
  //         return;
  //       }
  //       const remainingStock = data.currentStock + convertedQty;
  //       const isLowStock = remainingStock <= item.stockQty.minQty;
  //       if (isLowStock && !minQtyAlerted[item._id]) {
  //         alert(`Minimum Quantity Reached for ${item.itemName}`);
  //         setMinQtyAlerted((prev) => ({
  //           ...prev,
  //           [item._id]: true,
  //         }));
  //       }
  //       updatedCartItems.push({ ...item, quantity: item.isStaffReq ? quantity : 1, isLowStock });
  //     } else {
  //       updatedCartItems.push({ ...item, quantity: 1 });
  //     }
  //   }
  //   setCartItems(updatedCartItems);
  //   clearDiscount();
  // };

  // const handleAddToCart = async (item, quantity) => {
  //   const data = await getCurrentStockQty(item._id);
  //   const updatedCartItems = [...cartItems];
  //   const existingItem = updatedCartItems.find((cartItem) => cartItem._id === item._id);
  
  //   if (existingItem) {
  //     // Compute converted quantity for stock check
  //     const existingConvertedQty = await getConvertedQuantity(
  //       { ...existingItem, quantity: existingItem.quantity },
  //       "sale",
  //       item.units.stock.unit._id
  //     );
  //     if (existingItem.isStaffReq) {
  //       existingItem.quantity = quantity; // Set to provided quantity
  //       console.log("existing item Updated Quantity (isStaffReq)", existingItem.quantity);
  //     } else if (existingItem.toggleStock) {
  //       // Check stock with the proposed new quantity
  //       const newQuantity = existingItem.quantity + quantity;
  //       const proposedConvertedQty = await getConvertedQuantity(
  //         { ...existingItem, quantity: newQuantity },
  //         "sale",
  //         item.units.stock.unit._id
  //       );
  //       const remainingStock = data.currentStock + existingConvertedQty - proposedConvertedQty;
  //       // if (remainingStock < 0) {
  //       //   alert(`Not enough stock for ${existingItem.itemName}`);
  //       //   return;
  //       // }
  //       if (remainingStock <= existingItem.stockQty.minQty && !minQtyAlerted[existingItem._id]) {
  //         alert(`Minimum Quantity Reached for ${existingItem.itemName}`);
  //         setMinQtyAlerted((prev) => ({
  //           ...prev,
  //           [existingItem._id]: true,
  //         }));
  //       }
  //       existingItem.quantity = newQuantity; // Accumulate provided quantity
  //       existingItem.isLowStock = remainingStock <= existingItem.stockQty.minQty;
  //       console.log("existing item Updated Quantity (toggleStock)", existingItem.quantity);
  //     } else {
  //       existingItem.quantity += quantity; // Accumulate provided quantity
  //       console.log("existing item Updated Quantity (default)", existingItem.quantity);
  //     }
  //   } else {
  //     // Compute converted quantity for new item
  //     const convertedQty = await getConvertedQuantity(
  //       { ...item, quantity },
  //       "sale",
  //       item.units.stock.unit._id
  //     );
  //     if (item.isStaffReq) {
  //       updatedCartItems.push({ ...item, quantity });
  //       console.log("New item added (isStaffReq)", quantity);
  //     } else if (item.toggleStock) {
  //       const remainingStock = data.currentStock - convertedQty;
  //       // if (remainingStock < 0) {
  //       //   alert(`Not enough stock for ${item.itemName}`);
  //       //   return;
  //       // }
  //       const isLowStock = remainingStock <= item.stockQty.minQty;
  //       if (isLowStock && !minQtyAlerted[item._id]) {
  //         alert(`Minimum Quantity Reached for ${item.itemName}`);
  //         setMinQtyAlerted((prev) => ({
  //           ...prev,
  //           [item._id]: true,
  //         }));
  //       }
  //       updatedCartItems.push({ ...item, quantity, isLowStock });
  //       console.log("New item added (toggleStock)", quantity);
  //     } else {
  //       updatedCartItems.push({ ...item, quantity });
  //       console.log("New item added (default)", quantity);
  //     }
  //   }
  
  //   setCartItems(updatedCartItems);
  //   clearDiscount();
  // };

  const removeFromCart = (index) => {
    const updatedCartItems = [...cartItems];
    const removedItem = updatedCartItems[index];
    updatedCartItems.splice(index, 1);
    if (removedItem.toggleStock) {
      setMinQtyAlerted((prev) => {
        const newState = { ...prev };
        delete newState[removedItem._id];
        return newState;
      });
    }
    setCartItems(updatedCartItems);
    clearDiscount();
  };

  // const incrementQuantity = async (index) => {
  //   const updatedCartItems = [...cartItems];
  //   const item = updatedCartItems[index];
  //   const { quantity, stockQty, itemName, _id, toggleStock } = item;
  //   const currentConvertedQty = await getConvertedQuantity(item, "sale");

  //   if (toggleStock) {
  //     const data = await getCurrentStockQty(_id);
  //     const remainingStock = data.currentStock + currentConvertedQty;
  //     // if (remainingStock <= 0) {
  //     //   alert(`Not enough stock for ${itemName}`);
  //     //   return;
  //     // }
  //     if (remainingStock <= stockQty.minQty && !minQtyAlerted[_id]) {
  //       alert(`Minimum Quantity Reached for ${itemName}`);
  //       setMinQtyAlerted((prev) => ({
  //         ...prev,
  //         [_id]: true,
  //       }));
  //     }
  //     updatedCartItems[index].quantity++;
  //     updatedCartItems[index].isLowStock = remainingStock <= stockQty.minQty;
  //   } else {
  //     updatedCartItems[index].quantity++;
  //   }
  //   setCartItems(updatedCartItems);
  //   clearDiscount();
  // };

  // const decrementQuantity = async (index) => { // Made async
  //   const updatedCartItems = [...cartItems];
  //   if (updatedCartItems[index].quantity > 1) {
  //     const item = updatedCartItems[index];
  //     updatedCartItems[index].quantity--;
  //     if (item.toggleStock) {
  //       const data = await getCurrentStockQty(item._id); // Fetch stock data
  //       const remainingStock = data.currentStock + await getConvertedQuantity(item, "sale");
  //       item.isLowStock = remainingStock <= item.stockQty.minQty;
  //     }
  //     setCartItems(updatedCartItems);
  //     clearDiscount();
  //   }
  // };

  // const handleQuantityChange = async (event, index) => {
  //   const updatedCartItems = [...cartItems];
  //   const inputValue = event.target.value;
  //   const newQuantity = inputValue === "" ? "" : parseInt(inputValue, 10);
  //   const item = updatedCartItems[index];

  //   if (inputValue === "") {
  //     updatedCartItems[index].quantity = "";
  //     setCartItems(updatedCartItems);
  //     return;
  //   }

  //   if (isNaN(newQuantity) || newQuantity < 1) {
  //     alert("Quantity must be at least 1");
  //     updatedCartItems[index].quantity = 1;
  //     setCartItems(updatedCartItems);
  //     return;
  //   }

  //   if (item.toggleStock) {
  //     const data = await getCurrentStockQty(item._id);
  //     const newConvertedQty = await getConvertedQuantity({ ...item, quantity: newQuantity }, "sale");
  //     const remainingStock = data.currentStock + newConvertedQty;
  //     // if (-newConvertedQty > data.currentStock) {
  //     //   alert(`Not enough stock for ${item.itemName}`);
  //     //   updatedCartItems[index].quantity = Math.floor(
  //     //     data.currentStock / -await getConvertedQuantity({ ...item, quantity: 1 }, "sale")
  //     //   );
  //     //   setCartItems(updatedCartItems);
  //     //   return;
  //     // }
  //     if (remainingStock <= item.stockQty.minQty && !minQtyAlerted[item._id]) {
  //       alert(`Minimum Quantity Reached for ${item.itemName}`);
  //       setMinQtyAlerted((prev) => ({
  //         ...prev,
  //         [item._id]: true,
  //       }));
  //     }
  //     updatedCartItems[index].quantity = newQuantity;
  //     updatedCartItems[index].isLowStock = remainingStock <= item.stockQty.minQty;
  //   } else {
  //     updatedCartItems[index].quantity = newQuantity;
  //   }
  //   setCartItems(updatedCartItems);
  //   clearDiscount();
  // };

  const handleOpenQtyDialog = (index) => {
    console.log("handleOpenQtyDialog index: " + index);
    setSelectedIndex(index);
    setQtyDialogOpen(true);
  };

  const handleCloseQtyDialog = () => {
    setQtyDialogOpen(false);
  };

  // const getSubTotalPrice = () => {
  //   if (
  //     (profileDetail?.vatType === "inclusive" || profile.userProfile.vatType === "inclusive") &&
  //     (!profileDetail || profileDetail.vatType !== "exclusive")
  //   ) {
  //     let subTotal = 0;
  //     for (const item of cartItems) {
  //       subTotal +=
  //         item.quantity *
  //         Math.round(
  //           (parseFloat(item.units?.sale?.price) /
  //             (parseFloat(item.units?.sale?.price) + item.vat)) *
  //             item.units?.sale?.price
  //         );
  //     }
  //     // console.log(subTotal);
  //     return subTotal;
  //   }

  //   let subTotal = 0;
  //   for (const item of cartItems) {
  //     subTotal += item.quantity * item.units?.sale?.price;
  //   }
  //   return subTotal;
  // };

  // const calculateVat = () => {
  //   if (
  //     (profileDetail?.vatType === "inclusive" || profile.userProfile.vatType === "inclusive") &&
  //     (!profileDetail || profileDetail.vatType !== "exclusive")
  //   ) {
  //     let vat = 0;
  //     for (const item of cartItems) {
  //       vat +=
  //         item.quantity *
  //         Math.round(
  //           (item.units?.sale?.price /
  //             (parseFloat(item.units?.sale?.price) + item.vat)) *
  //             item.vat
  //         );
  //     }
  //     return vat;
  //   }

  //   let vat = 0;
  //   if (discountFlag && discountType) {
  //     for (const item of cartItems) {
  //       vat +=
  //         item.quantity *
  //         (parseFloat(item.units?.sale?.price) -
  //           parseFloat(item.units?.sale?.price) * (discountRate / 100)) *
  //         (item.vat / 100);
  //     }
  //   } else if (discountFlag && !discountType) {
  //     const subTotal = getSubTotalPrice();
  //     for (const item of cartItems) {
  //       vat +=
  //         (item.quantity * parseFloat(item.units?.sale?.price) -
  //           (discountVal / subTotal) * (item.quantity * parseFloat(item.units?.sale?.price))) *
  //         (item.vat / 100);
  //     }
  //   } else {
  //     for (const item of cartItems) {
  //       vat += item.quantity * parseFloat(item.units?.sale?.price) * (item.vat / 100);
  //     }
  //   }
  //   return vat;
  // };

  // const getTotalPrice = () => {
  //   const totalPrice =
  //     parseFloat(getSubTotalPrice().toFixed(2)) -
  //     (discountFlag ? parseFloat(discountVal) : 0) +
  //     parseFloat(calculateVat());
  //   return totalPrice;
  // };

  // const calculateChange = () => {
  //   const total = getTotalPrice();
  //   if (receivedAmount >= total) {
  //     return (receivedAmount - total).toFixed(2);
  //   } else {
  //     return "";
  //   }
  // };


  

  // const calculatePrice = (quantity, price) => (quantity * price).toFixed(2);

  //----------------------------------------------------------------------------------------------

  const getSubTotalPrice = () => {
    let subTotal = 0;
    for (const item of cartItems) {
      const price = getEffectiveUnitPrice(item);
      const vatRate = getVatRate(item);
      const quantity = item.quantity || 1;

      if (isVatInclusive()) {
        const priceExclVat = price / (1 + vatRate / 100);
        subTotal += quantity * priceExclVat;
      } else {
        subTotal += quantity * price;
      }
    }
    return parseFloat(subTotal.toFixed(2));
  };

  const getOriginalSubTotalPrice = () => {
    let subTotal = 0;
    for (const item of cartItems) {
      const price = getOriginalUnitPrice(item);
      const vatRate = getVatRate(item);
      const quantity = item.quantity || 1;

      if (isVatInclusive()) {
        const priceExclVat = price / (1 + vatRate / 100);
        subTotal += quantity * priceExclVat;
      } else {
        subTotal += quantity * price;
      }
    }
    return parseFloat(subTotal.toFixed(2));
  };

  const calculateVat = () => {
    let vat = 0;
    for (const item of cartItems) {
      const price = getEffectiveUnitPrice(item);
      const vatRate = getVatRate(item);
      const quantity = item.quantity || 1;

      if (isVatInclusive()) {
        const priceExclVat = price / (1 + vatRate / 100);
        const vatAmount = price - priceExclVat;
        vat += quantity * vatAmount;
      } else {
        let priceAfterDiscount = price;
        if (discountFlag && discountType) {
          priceAfterDiscount = price * (1 - discountRate / 100);
        } else if (discountFlag && !discountType) {
          const subTotal = getSubTotalPrice() || 1;
          const itemTotal = quantity * price;
          priceAfterDiscount =
            price - (discountVal * (itemTotal / subTotal)) / quantity;
        }
        vat += quantity * priceAfterDiscount * (vatRate / 100);
      }
    }
    return parseFloat(vat.toFixed(2));
  };

  const getTotalPrice = () => {
    const subTotal = getSubTotalPrice();
    const vat = calculateVat();
    const totalPrice = subTotal - (discountFlag ? parseFloat(discountVal) : 0) + vat;
    return parseFloat(totalPrice.toFixed(2));
  };

  const calculateChange = () => {
    const total = getTotalPrice();
    if (receivedAmount >= total) {
      return (receivedAmount - total).toFixed(2);
    } else {
      return "";
    }
  };

  const calculatePrice = (item) =>
    ((item?.quantity || 0) * getEffectiveUnitPrice(item)).toFixed(2);

  //------------------------------------------------------------------
  // Helper function to handle minimum stock alerts
const handleMinStockAlert = (item, remainingStock, minQtyAlerted, setMinQtyAlerted) => {
  const isLowStock = remainingStock <= item.stockQty.minQty;
  if (isLowStock && !minQtyAlerted[item._id]) {
    alert(`Minimum Quantity Reached for ${item.itemName}`);
    setMinQtyAlerted((prev) => ({
      ...prev,
      [item._id]: true,
    }));
  } else if (!isLowStock && minQtyAlerted[item._id]) {
    // Reset alert if stock goes above minimum
    setMinQtyAlerted((prev) => {
      const newState = { ...prev };
      delete newState[item._id];
      return newState;
    });
  }
  return isLowStock;
};

// const handleAddToCart = async (item, quantity) => {
//   const data = await getCurrentStockQty(item._id);
//   const updatedCartItems = [...cartItems];
//   const existingItem = updatedCartItems.find((cartItem) => cartItem._id === item._id);

//   if (existingItem) {
//     // Compute current converted quantity in cart
//     const existingConvertedQty = await getConvertedQuantity(
//       { ...existingItem, quantity: existingItem.quantity },
//       "sale",
//       item.units.stock.unit._id
//     );
//     if (existingItem.isStaffReq) {
//       existingItem.quantity = quantity;
//       console.log("existing item Updated Quantity (isStaffReq)", existingItem.quantity);
//     } else if (existingItem.toggleStock) {
//       // Compute proposed new quantity and converted quantity
//       const newQuantity = existingItem.quantity + quantity;
//       const proposedConvertedQty = await getConvertedQuantity(
//         { ...existingItem, quantity: newQuantity },
//         "sale",
//         item.units.stock.unit._id
//       );
//       const remainingStock = data.currentStock - proposedConvertedQty;

//       // if (remainingStock < 0) {
//       //   alert(`Not enough stock for ${existingItem.itemName}`);
//       //   return;
//       // }

//       // Handle minimum stock alert
//       existingItem.isLowStock = handleMinStockAlert(
//         existingItem,
//         remainingStock,
//         minQtyAlerted,
//         setMinQtyAlerted
//       );

//       existingItem.quantity = newQuantity;
//       console.log("existing item Updated Quantity (toggleStock)", existingItem.quantity);
//     } else {
//       existingItem.quantity += quantity;
//       console.log("existing item Updated Quantity (default)", existingItem.quantity);
//     }
//   } else {
//     // Compute converted quantity for new item
//     const convertedQty = await getConvertedQuantity(
//       { ...item, quantity },
//       "sale",
//       item.units.stock.unit._id
//     );
//     if (item.isStaffReq) {
//       updatedCartItems.push({ ...item, quantity });
//       console.log("New item added (isStaffReq)", quantity);
//     } else if (item.toggleStock) {
//       const remainingStock = data.currentStock - convertedQty;
//       // if (remainingStock < 0) {
//       //   alert(`Not enough stock for ${item.itemName}`);
//       //   return;
//       // }

//       // Handle minimum stock alert
//       const isLowStock = handleMinStockAlert(item, remainingStock, minQtyAlerted, setMinQtyAlerted);

//       updatedCartItems.push({ ...item, quantity, isLowStock });
//       console.log("New item added (toggleStock)", quantity);
//     } else {
//       updatedCartItems.push({ ...item, quantity });
//       console.log("New item added (default)", quantity);
//     }
//   }

//   setCartItems(updatedCartItems);
//   clearDiscount();
// };

const handleAddToCart = async (item, quantity) => {
  if (!item || !item._id) {
    console.error("Invalid item or missing _id:", item);
    return;
  }
  if (!quantity || quantity < 1) {
    console.error("Invalid quantity:", quantity);
    return;
  }

  const updatedCartItems = [...cartItems];
  const existingItem = updatedCartItems.find((cartItem) => cartItem._id === item._id);
  const basePrice =
    parsePriceValue(item.originalPrice) ??
    parsePriceValue(item.units?.sale?.price) ??
    parsePriceValue(item.rate) ??
    0;
  const overrideIncoming = parsePriceValue(item.overridePrice);
  const effectiveIncoming =
    overrideIncoming != null && overrideIncoming > 0
      ? overrideIncoming
      : parsePriceValue(item.units?.sale?.price) ??
        parsePriceValue(item.rate) ??
        basePrice;

  if (orderSession?.activeSessionId) {
    try {
      const sessionItems = orderSession.activeSession?.items || [];
      const normalizeId = (val) => (val == null ? "" : String(val));
      const sameRemark = (a, b) => (a ?? "") === (b ?? "");
      const almostEqual = (a, b) => Math.abs((parseFloat(a) || 0) - (parseFloat(b) || 0)) < 0.0001;

      const matchIndex = sessionItems.findIndex((si) => {
        const siItemId = si.itemId?._id || si.itemId;
        if (normalizeId(siItemId) !== normalizeId(item._id)) return false;
        if (si.kotPrinted) return false;
        if (!sameRemark(si.remark, item.remark)) return false;
        const siRate = parseFloat(si.rate ?? 0);
        const siOriginal = parseFloat(si.originalRate ?? si.rate ?? 0);
        if (!almostEqual(siRate, effectiveIncoming)) return false;
        if (!almostEqual(siOriginal, basePrice)) return false;
        return true;
      });

      if (matchIndex >= 0) {
        const current = sessionItems[matchIndex];
        const nextQty = (current.qty || 0) + quantity;
        await orderSession.updateItemInSession(orderSession.activeSessionId, {
          index: matchIndex,
          qty: nextQty,
        });
      } else {
        await orderSession.addItemToSession(orderSession.activeSessionId, { ...item, quantity });
      }
    } catch (err) {
      console.error("Failed to add to session:", err);
      return;
    }
  }

  if (existingItem) {
    console.log("Existing item found:", existingItem); // Debug log
    if (existingItem.originalPrice == null || Number.isNaN(existingItem.originalPrice)) {
      existingItem.originalPrice = basePrice;
    }
    if (existingItem.isStaffReq) {
      existingItem.quantity = quantity;
      console.log("Existing item updated quantity (isStaffReq):", existingItem.quantity);
    } else if (existingItem.toggleStock) {
      // Stock checks only for toggleStock: true
      const data = await getCurrentStockQty(item._id);
      const proposedConvertedQty = await getConvertedQuantity(
        { ...existingItem, quantity: existingItem.quantity + quantity },
        "sale",
        item.units?.stock?.unit?._id
      );
      const remainingStock = data.currentStock - proposedConvertedQty;

      // Uncomment if stock validation is needed
      // if (remainingStock < 0) {
      //   alert(`Not enough stock for ${existingItem.itemName}`);
      //   return;
      // }

      // Handle minimum stock alert
      existingItem.isLowStock = handleMinStockAlert(
        existingItem,
        remainingStock,
        minQtyAlerted,
        setMinQtyAlerted
      );
      existingItem.quantity += quantity;
      console.log("Existing item updated quantity (toggleStock):", existingItem.quantity);
    } else {
      // No stock checks for toggleStock: false
      existingItem.quantity += quantity;
      console.log("Existing item updated quantity (default):", existingItem.quantity);
    }
    if (overrideIncoming != null && overrideIncoming > 0) {
      existingItem.overridePrice = overrideIncoming;
    }
    existingItem.priceAdjusted = isItemPriceAdjusted(existingItem);
  } else {
    console.log("Adding new item:", item); // Debug log
    if (item.isStaffReq) {
      updatedCartItems.push({
        ...item,
        quantity,
        originalPrice: basePrice,
        overridePrice: overrideIncoming,
        priceAdjusted:
          overrideIncoming != null && Math.abs(overrideIncoming - basePrice) > 0.0001,
      });
      console.log("New item added (isStaffReq):", quantity);
    } else if (item.toggleStock) {
      // Stock checks only for toggleStock: true
      const data = await getCurrentStockQty(item._id);
      const convertedQty = await getConvertedQuantity(
        { ...item, quantity },
        "sale",
        item.units?.stock?.unit?._id
      );
      const remainingStock = data.currentStock - convertedQty;

      // Uncomment if stock validation is needed
      // if (remainingStock < 0) {
      //   alert(`Not enough stock for ${item.itemName}`);
      //   return;
      // }

      // Handle minimum stock alert
      const isLowStock = handleMinStockAlert(item, remainingStock, minQtyAlerted, setMinQtyAlerted);
      updatedCartItems.push({
        ...item,
        quantity,
        isLowStock,
        originalPrice: basePrice,
        overridePrice: overrideIncoming,
        priceAdjusted:
          overrideIncoming != null && Math.abs(overrideIncoming - basePrice) > 0.0001,
      });
      console.log("New item added (toggleStock):", quantity);
    } else {
      // No stock checks for toggleStock: false
      updatedCartItems.push({
        ...item,
        quantity,
        originalPrice: basePrice,
        overridePrice: overrideIncoming,
        priceAdjusted:
          overrideIncoming != null && Math.abs(overrideIncoming - basePrice) > 0.0001,
      });
      console.log("New item added (default):", quantity);
    }
  }

  console.log("Updated cart items:", updatedCartItems); // Debug log
  setCartItems(updatedCartItems);
  clearDiscount();
};

const incrementQuantity = async (index) => {
  const updatedCartItems = [...cartItems];
  const item = updatedCartItems[index];
  const { _id, toggleStock } = item;

  if (toggleStock) {
    const data = await getCurrentStockQty(_id);
    const proposedConvertedQty = await getConvertedQuantity(
      { ...item, quantity: item.quantity + 1 },
      "sale",
      item.units.stock.unit._id
    );
    const remainingStock = data.currentStock - proposedConvertedQty;

    // if (remainingStock < 0) {
    //   alert(`Not enough stock for ${itemName}`);
    //   return;
    // }

    // Handle minimum stock alert
    updatedCartItems[index].isLowStock = handleMinStockAlert(
      item,
      remainingStock,
      minQtyAlerted,
      setMinQtyAlerted
    );

    updatedCartItems[index].quantity++;
  } else {
    updatedCartItems[index].quantity++;
  }
  setCartItems(updatedCartItems);
  clearDiscount();
};

const decrementQuantity = async (index) => {
  const updatedCartItems = [...cartItems];
  const item = updatedCartItems[index];

  if (item.quantity > 1) {
    if (item.toggleStock) {
      const data = await getCurrentStockQty(item._id);
      const newConvertedQty = await getConvertedQuantity(
        { ...item, quantity: item.quantity - 1 },
        "sale",
        item.units.stock.unit._id
      );
      const remainingStock = data.currentStock - newConvertedQty;

      // Handle minimum stock alert
      updatedCartItems[index].isLowStock = handleMinStockAlert(
        item,
        remainingStock,
        minQtyAlerted,
        setMinQtyAlerted
      );
    }
    updatedCartItems[index].quantity--;
    setCartItems(updatedCartItems);
    clearDiscount();
  }
};

const handleQuantityChange = async (event, index) => {
  const updatedCartItems = [...cartItems];
  const inputValue = event.target.value;
  const newQuantity = inputValue === "" ? "" : parseInt(inputValue, 10);
  const item = updatedCartItems[index];

  if (inputValue === "") {
    updatedCartItems[index].quantity = "";
    setCartItems(updatedCartItems);
    return;
  }

  if (isNaN(newQuantity) || newQuantity < 1) {
    alert("Quantity must be at least 1");
    updatedCartItems[index].quantity = 1;
    setCartItems(updatedCartItems);
    return;
  }

  if (item.toggleStock) {
    const data = await getCurrentStockQty(item._id);
    const newConvertedQty = await getConvertedQuantity(
      { ...item, quantity: newQuantity },
      "sale",
      item.units.stock.unit._id
    );
    const remainingStock = data.currentStock - newConvertedQty;

    // if (remainingStock < 0) {
    //   alert(`Not enough stock for ${item.itemName}`);
    //   const maxAffordableQty = Math.floor(
    //     data.currentStock / (await getConvertedQuantity({ ...item, quantity: 1 }, "sale", item.units.stock.unit._id))
    //   );
    //   updatedCartItems[index].quantity = maxAffordableQty > 0 ? maxAffordableQty : 1;
    //   setCartItems(updatedCartItems);
    //   return;
    // }

    // Handle minimum stock alert
    updatedCartItems[index].isLowStock = handleMinStockAlert(
      item,
      remainingStock,
      minQtyAlerted,
      setMinQtyAlerted
    );

    updatedCartItems[index].quantity = newQuantity;
  } else {
    updatedCartItems[index].quantity = newQuantity;
  }
  setCartItems(updatedCartItems);
  clearDiscount();
};

const updateItemPrice = async (index, value) => {
  const updatedCartItems = [...cartItems];
  if (index < 0 || index >= updatedCartItems.length) return;
  const item = { ...updatedCartItems[index] };

  if (item.originalPrice == null || Number.isNaN(item.originalPrice)) {
    item.originalPrice = getOriginalUnitPrice(item);
  }

  const parsed = parsePriceValue(value);
  if (parsed != null && parsed > 0) {
    item.overridePrice = parsed;
  } else {
    item.overridePrice = null;
  }
  item.priceAdjusted = isItemPriceAdjusted(item);

  updatedCartItems[index] = item;
  setCartItems(updatedCartItems);
  clearDiscount();

  if (orderSession?.activeSessionId && item?._id) {
    try {
      await orderSession.updateItemInSession(orderSession.activeSessionId, {
        itemId: item._id,
        rate: getEffectiveUnitPrice(item),
        originalRate: getOriginalUnitPrice(item),
        priceAdjusted: item.priceAdjusted,
      });
      if (typeof orderSession.refreshActiveSession === "function") {
        await orderSession.refreshActiveSession();
      }
    } catch (error) {
      console.error("Failed to update session item price:", error);
    }
  }
};

  return (
    <CartContext.Provider
      value={{
        cartItems,
        QtydialogOpen,
        selectedIndex,
        receivedAmount,
        handleAddToCart,
        removeFromCart,
        incrementQuantity,
        decrementQuantity,
        calculatePrice,
        getTotalPrice,
        getSubTotalPrice,
        getOriginalSubTotalPrice,
        getEffectiveUnitPrice,
        getOriginalUnitPrice,
        isItemPriceAdjusted,
        handleOpenQtyDialog,
        handleCloseQtyDialog,
        handleQuantityChange,
        updateItemPrice,
        setReceivedAmount,
        calculateChange,
        calculateVat,
        setCartItems,
        selectedCategory,
        setSelectedCategory,
        filterItemsByCategory,
        searchQuery,
        setSearchQuery,
        vat,
        setVat,
        getInvoiceNumber,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}
